import { useMutation } from '@tanstack/react-query';
import Config from 'src/common/Config';

const API_URL = Config.getApiUrl();

export function useDeleteDocumentVersions(documentId?: string) {
  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation({
    mutationFn: async (versionIds: string[]) => {
      if (!documentId) throw new Error('documentId is required');
      const response = await fetch(`${API_URL}/documents/${documentId}/versions/delete`, {
        method: 'POST',
        body: JSON.stringify({ versionIds }),
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.status < 200 || response.status > 299) throw response;
    },
  });

  const deleteDocumentVersions = async (versionIds: string[]) => {
    return mutateAsync(versionIds);
  };

  return {
    deleteDocumentVersions,
    error,
    isLoading,
    reset,
  };
}
